module.exports = __webpack_public_path__ + "static/media/portafoglio.8a9071cc.svg";